export default [
  {
    path: '/choseFinanceReportSetting',
    name: 'ChoseFinanceReportSetting',
    component: () => import('@/views/financeReportSetting/ChoseFinanceReportSetting.vue'),
    meta: {},
  },
];
